<template>
  <div id="nacsos-logo">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
      version="1.1"
      id="svg5"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:svg="http://www.w3.org/2000/svg"
    >
      <defs id="defs2">
        <linearGradient id="a">
          <stop offset="0" stop-color="#c3dcda" id="stop9" />
          <stop offset="1" stop-color="#c3dcda" stop-opacity="0" id="stop11" />
        </linearGradient>
        <linearGradient
          id="b"
          x1="109.759"
          x2="114.215"
          y1="344.03201"
          y2="339.755"
          xlink:href="#a"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.04023,0,0,0.04023,34.798167,93.764712)"
        />
      </defs>
      <g id="layer3" transform="translate(-30.883,-72.041)">
        <path
          fill="#a2a4a4"
          d="m 130.62047,121.91982 a 49.868738,49.868738 0 1 1 -99.737469,0 49.868738,49.868738 0 1 1 99.737469,0 z"
          id="logo-ring-outer"
          style="stroke-width: 6.88318"
        />
        <path
          fill="#7fc0c4"
          d="m 128.89967,121.91982 a 48.147938,48.147938 0 1 1 -96.295869,0 48.147938,48.147938 0 1 1 96.295869,0 z"
          id="logo-ring-inner"
          style="stroke-width: 6.88318"
        />
        <path
          fill="#007c85"
          d="m 125.45119,121.91982 a 44.699459,44.699459 0 1 1 -89.398909,0 44.699459,44.699459 0 1 1 89.398909,0 z"
          id="logo-background"
          style="stroke-width: 6.88318"
        />
        <g
          aria-label="NAC"
          id="text2611"
          style="font-size: 5.48401px; line-height: 1.25; stroke-width: 0.137101"
          transform="matrix(6.8831934,0,0,6.8831934,-181.69066,-423.82105)"
        >
          <path
            d="m 36.615309,75.375193 h -1.288743 v 0.104196 c 0.438721,0.02742 0.510013,0.120648 0.526465,0.701953 v 1.848112 l -2.111344,-2.654261 h -0.937765 v 0.104196 c 0.235812,0 0.312588,0.04387 0.531949,0.301621 v 2.418448 c -0.01097,0.581305 -0.08226,0.674533 -0.531949,0.701953 v 0.104197 h 1.288742 v -0.104197 c -0.422269,-0.02194 -0.504529,-0.1371 -0.515497,-0.701953 v -2.149732 l 2.423932,3.016206 h 0.09323 v -2.88459 c 0.01645,-0.570337 0.08774,-0.663565 0.520981,-0.701953 z"
            style="
              font-family: serif;
              fill: #cccccc;
              stroke: #575757;
              stroke-width: 0.290563;
              stroke-miterlimit: 4;
              stroke-dasharray: none;
              stroke-opacity: 1;
              paint-order: stroke fill markers;
            "
            id="logo-nac-n"
          />
          <path
            d="m 40.410248,78.901411 c -0.24678,-0.01645 -0.301621,-0.07129 -0.493561,-0.477108 l -1.365518,-3.114918 h -0.109681 l -1.140674,2.692649 c -0.350976,0.800665 -0.416785,0.888409 -0.680017,0.899377 v 0.104197 h 1.085834 v -0.104197 c -0.263233,0 -0.372913,-0.06581 -0.372913,-0.224844 0,-0.06581 0.01645,-0.142584 0.04387,-0.213876 l 0.252265,-0.64163 h 1.43681 l 0.224845,0.526465 c 0.06581,0.148069 0.104196,0.290653 0.104196,0.367429 0,0.1371 -0.09323,0.180972 -0.383881,0.186456 v 0.104197 h 1.398423 z m -2.687165,-1.305194 0.630661,-1.508103 0.636145,1.508103 z"
            style="
              font-family: serif;
              fill: #cccccc;
              stroke: #575757;
              stroke-width: 0.290563;
              stroke-miterlimit: 4;
              stroke-dasharray: none;
              stroke-opacity: 1;
              paint-order: stroke fill markers;
            "
            id="logo-nac-a"
          />
          <path
            d="m 43.580004,76.532319 -0.04936,-1.233902 h -0.115165 c -0.0329,0.115164 -0.120648,0.180972 -0.230328,0.180972 -0.04936,0 -0.131616,-0.01645 -0.213876,-0.04387 -0.268717,-0.09323 -0.542917,-0.1371 -0.800666,-0.1371 -0.449689,0 -0.904862,0.170004 -1.24487,0.471625 -0.383881,0.340008 -0.592273,0.844537 -0.592273,1.447778 0,1.118738 0.729373,1.864564 1.820691,1.864564 0.619693,0 1.168094,-0.252265 1.497135,-0.69647 l -0.09871,-0.09871 c -0.400333,0.389365 -0.767762,0.553885 -1.222935,0.553885 -0.345492,0 -0.652597,-0.10968 -0.888409,-0.318072 -0.301621,-0.268717 -0.471625,-0.762278 -0.471625,-1.376487 0,-0.992606 0.510013,-1.628751 1.305194,-1.628751 0.312589,0 0.597757,0.115164 0.817118,0.329041 0.175488,0.175488 0.257748,0.32904 0.361944,0.685501 z"
            style="
              font-family: serif;
              fill: #cccccc;
              stroke: #575757;
              stroke-width: 0.290563;
              stroke-linejoin: round;
              stroke-miterlimit: 4;
              stroke-dasharray: none;
              stroke-opacity: 1;
              paint-order: stroke fill markers;
            "
            id="logo-nac-c"
          />
        </g>
        <path
          fill="#ffffff"
          fill-rule="evenodd"
          d="m 36.114131,121.38522 c 27.843419,-8.20496 64.390069,-5.98195 89.226779,3.88106 -0.0242,0.35543 -0.19584,1.86931 -0.23824,2.31324 -29.42613,-10.35872 -57.375875,-10.82152 -88.483311,0.84017 -0.512798,-3.17227 -0.656106,-5.53633 -0.671525,-7.04294 z"
          id="logo-horizon"
          style="display: inline; stroke-width: 7.62017"
        />
        <path
          d="m 125.12599,127.64147 c -4.41571,25.70456 -23.88191,39.46262 -44.374254,38.97781 -19.765721,-0.46764 -39.315265,-11.66326 -44.226003,-38.1707 34.646222,-12.59071 56.850737,-10.64715 88.600257,-0.80711 z"
          id="logo-foreground"
          style="stroke-width: 6.88318"
        />
        <g
          id="logo-sos"
          :class="{ 'jump-sos': loading }"
          aria-label="SOS"
          style="
            font-size: 9.29538px;
            line-height: 1.25;
            stroke: #ffffff;
            stroke-width: 0.5;
            stroke-linecap: butt;
            stroke-linejoin: round;
            stroke-miterlimit: 4;
            stroke-dasharray: none;
            stroke-opacity: 1;
            paint-order: stroke fill markers;
          "
        >
          <path
            d="m 63.915932,124.72405 h -0.736997 c -0.140374,0.77209 -0.526427,1.19324 -1.123041,1.19324 -0.350937,0 -0.947566,-0.14038 -1.544184,-0.42115 -1.298518,-0.49133 -2.597035,-0.77209 -3.75517,-0.77209 -1.473993,0 -3.018178,0.59662 -4.176317,1.61437 -1.228326,1.08795 -1.860038,2.56195 -1.860038,4.38689 0,2.8076 1.544184,4.77293 5.474834,6.84354 2.526843,1.3687 4.351788,2.77251 5.229163,4.10612 0.315861,0.45624 0.49133,1.19323 0.49133,2.07061 0,2.31628 -1.754754,3.93065 -4.316691,3.93065 -3.158556,0 -5.334452,-1.93023 -7.089205,-6.21183 h -0.807188 l 1.052855,7.44015 h 0.77209 c 0.03511,-0.6668 0.456236,-1.15813 0.982663,-1.15813 0.386045,0 0.98266,0.14037 1.649469,0.38604 1.333611,0.52643 2.77251,0.80719 4.141215,0.80719 4.071028,0 7.159396,-2.77251 7.159396,-6.4224 0,-2.87779 -1.930229,-5.12388 -6.562778,-7.65072 -3.684982,-2.00042 -5.158976,-3.54461 -5.158976,-5.47483 0,-1.93023 1.473994,-3.22875 3.649886,-3.22875 1.579281,0 3.053274,0.6668 4.281601,1.93023 1.087948,1.12304 1.579277,2.03551 2.140798,4.10612 h 0.877375 z"
            style="
              font-family: serif;
              fill: #cccccc;
              stroke: #ffffff;
              stroke-width: 0.5;
              stroke-linecap: butt;
              stroke-linejoin: round;
              stroke-miterlimit: 4;
              stroke-dasharray: none;
              stroke-opacity: 1;
              paint-order: stroke fill markers;
            "
            id="logo-sos-s1"
          />
          <path
            d="m 79.778908,124.72405 c -6.70316,0 -11.476091,5.0186 -11.476091,12.1078 0,3.29894 1.123046,6.52768 3.018178,8.5281 2.035513,2.21099 5.158975,3.5797 8.24734,3.5797 6.913729,0 11.68666,-4.87821 11.68666,-11.96742 0,-3.47441 -1.017757,-6.49259 -2.947987,-8.56319 -2.210989,-2.42157 -5.158975,-3.68499 -8.5281,-3.68499 z m 0,1.26342 c 1.614371,0 3.228743,0.63172 4.492166,1.75476 1.895136,1.71966 2.98308,5.01859 2.98308,9.19491 0,2.0706 -0.421139,4.49216 -1.158135,6.31711 -0.315862,0.87738 -0.912472,1.75475 -1.71966,2.56194 -1.228326,1.22832 -2.807604,1.86004 -4.667642,1.86004 -1.614375,0 -3.193653,-0.63172 -4.457073,-1.71966 -1.789851,-1.61437 -2.947986,-5.15898 -2.947986,-9.05453 0,-3.5797 0.982659,-6.98392 2.456652,-8.63339 1.368709,-1.50908 3.088369,-2.28118 5.018598,-2.28118 z"
            style="
              font-family: serif;
              fill: #cccccc;
              stroke: #ffffff;
              stroke-width: 0.5;
              stroke-linecap: butt;
              stroke-linejoin: round;
              stroke-miterlimit: 4;
              stroke-dasharray: none;
              stroke-opacity: 1;
              paint-order: stroke fill markers;
            "
            id="logo-sos-o"
          />
          <path
            d="m 107.71461,124.72405 h -0.737 c -0.14037,0.77209 -0.52642,1.19324 -1.12304,1.19324 -0.35093,0 -0.94756,-0.14038 -1.54418,-0.42115 -1.29852,-0.49133 -2.59704,-0.77209 -3.75517,-0.77209 -1.473994,0 -3.018178,0.59662 -4.176313,1.61437 -1.22833,1.08795 -1.860038,2.56195 -1.860038,4.38689 0,2.8076 1.54418,4.77293 5.47483,6.84354 2.526841,1.3687 4.351791,2.77251 5.229161,4.10612 0.31586,0.45624 0.49134,1.19323 0.49134,2.07061 0,2.31628 -1.75476,3.93065 -4.3167,3.93065 -3.158555,0 -5.334451,-1.93023 -7.089204,-6.21183 h -0.807184 l 1.05285,7.44015 h 0.772091 c 0.03511,-0.6668 0.456236,-1.15813 0.982663,-1.15813 0.386045,0 0.982663,0.14037 1.649469,0.38604 1.333611,0.52643 2.772515,0.80719 4.141215,0.80719 4.07103,0 7.1594,-2.77251 7.1594,-6.4224 0,-2.87779 -1.93023,-5.12388 -6.56278,-7.65072 -3.684985,-2.00042 -5.158978,-3.54461 -5.158978,-5.47483 0,-1.93023 1.473993,-3.22875 3.649888,-3.22875 1.57928,0 3.05327,0.6668 4.2816,1.93023 1.08795,1.12304 1.57928,2.03551 2.1408,4.10612 h 0.87738 z"
            style="
              font-family: serif;
              fill: #cccccc;
              stroke: #ffffff;
              stroke-width: 0.5;
              stroke-linecap: butt;
              stroke-linejoin: round;
              stroke-miterlimit: 4;
              stroke-dasharray: none;
              stroke-opacity: 1;
              paint-order: stroke fill markers;
            "
            id="logo-sos-s2"
          />
        </g>
        <path
          d="m 47.765263,114.27197 c -0.07551,4.00124 -0.570476,4.63127 -3.665753,4.82001 v 0.7172 h 8.870662 v -0.7172 c -2.906561,-0.15103 -3.466956,-0.89832 -3.542452,-4.78632 -0.414709,-0.13988 -1.224883,-0.0427 -1.662457,-0.0336 z"
          style="
            font-family: serif;
            fill: #cccccc;
            stroke: none;
            stroke-width: 0.206496;
            stroke-miterlimit: 4;
            stroke-dasharray: none;
            stroke-opacity: 1;
          "
          id="logo-n-foot-fill"
        />
        <path
          style="
            fill: none;
            stroke: #575757;
            stroke-width: 1;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke-miterlimit: 4;
            stroke-dasharray: none;
            stroke-opacity: 1;
            paint-order: stroke fill markers;
          "
          d="m 47.273021,113.78945 c -0.02832,4.21996 -1.233882,4.7568 -3.717556,4.80555 l -0.0063,1.20289 8.996767,0.006 -0.0058,-1.30306 c -2.150479,0.0406 -2.673835,-0.55977 -2.606876,-4.69321"
          id="logo-n-foot-outline"
        />
      </g>
    </svg>
    <div class="spinframe" :class="{ spin: loading }" style="height: 100%; width: 100%" id="nacsos-logo-spinframe1" />
    <div class="spinframe" :class="{ spin: loading }" style="height: 100%; width: 100%" id="nacsos-logo-spinframe2" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { requestsStore } from "@/stores";

export default defineComponent({
  name: "NacsosLogo",
  props: {
    animated: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    // pass
  },
  computed: {
    loading() {
      return this.animated || requestsStore.hasActiveRequest;
    },
  },
});
</script>

<style scoped>
#nacsos-logo {
  position: relative;
  display: inline-block;
}

.jump-sos > path {
  -webkit-animation: jump 1s ease alternate infinite;
  animation: jump 1s ease alternate infinite;
}

#logo-sos-s1 {
  -webkit-animation-delay: 0.1s;
  animation-delay: 0.1s;
}

#logo-sos-o {
  -webkit-animation-delay: 0.2s;
  animation-delay: 0.2s;
}

#logo-sos-s2 {
  -webkit-animation-delay: 0.3s;
  animation-delay: 0.3s;
}

@-webkit-keyframes jump {
  90% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-10px);
  }
}

@keyframes jump {
  90% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-10px);
  }
}

.spinframe {
  display: block;
  border: 3px solid hsla(0, 0%, 100%, 0.3);
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;
}

.spin#nacsos-logo-spinframe1 {
  border-top-color: #575ab1;
  animation: spin 2s linear infinite;
  -webkit-animation: spin 2s linear infinite;
}

.spin#nacsos-logo-spinframe2 {
  border-bottom-color: #ff0000a6;
  animation: spin 1.5s linear infinite;
  -webkit-animation: spin 1.5s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
  }
}
</style>
